import { getQueryParam } from '../../../utils/url-helpers'
import { _scrollTo, scrollableContentSelector } from '../../../utils/domHelpers'
import { isDOM } from '@app/shared/predicates'
import { waitForLiveInputsInitialization } from '@app/application/reconciliation/utils'
import { v4 as generateUuid } from 'uuid'
import { SfLog } from '@app/adapters/logger'
import { isUsingNewLayout } from '@app/adapters/silverfin'

const LIQUID_PATH_URL_PARAM = 'focused_liquid_path'
const MAXIMUM_AWAIT_TIME_FOR_LIVE_INPUT_INIT = 5000

export async function scrollToLiquidPathUrl(): Promise<void> {
  const liquidPath = getQueryParam(LIQUID_PATH_URL_PARAM) as string | null

  let dataName = liquidPath

  if (!liquidPath) return

  let field = document.querySelector(
    `[data-name="${liquidPath}"]`
  ) as HTMLInputElement
  if (!field) return

  const isCheckbox = field.classList.contains('sf-hidden')

  if (
    isCheckbox &&
    field.parentElement &&
    field.parentElement.querySelector('.sf-form-check-content')
  ) {
    field = field.parentElement.querySelector(
      '.sf-form-check-content'
    ) as HTMLInputElement

    if (!field.hasAttribute('data-name')) {
      dataName = `${liquidPath}-checkbox-${generateUuid()}`
      field.setAttribute('data-name', dataName)
    } else {
      dataName = field.getAttribute('data-name')
    }
  }

  if (!field) return

  try {
    await waitForLiveInputsInitialization(
      MAXIMUM_AWAIT_TIME_FOR_LIVE_INPUT_INIT
    )

    const target = document.querySelector(
      `#main-content [data-name="${dataName}"]`
    )

    const usingNewLayout = isUsingNewLayout()

    if (usingNewLayout) {
      target?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    } else {
      await _scrollTo(`[data-name="${dataName}"]`, scrollableContentSelector)
    }

    if (!isCheckbox) {
      window.eventHub.$emit('focus-live-input', field)
    }

    if (field.setSelectionRange) {
      const fieldTextSize = field.value.length
      field.setSelectionRange(fieldTextSize, fieldTextSize)
    }
  } catch (error) {
    SfLog.info('Failed to initialize live inputs', {
      extra: {
        error,
      },
    })
  }
}

export default (): void => {
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  window.onDomLoad(async ($dom) => {
    const doc = $dom[0]

    if (isDOM(doc)) {
      await scrollToLiquidPathUrl()
    }
  })
}
